import { Text } from "@zapier/design-system";
import { CrossDomainImage } from "../CrossDomainImage/CrossDomainImage";
import { ZapCard } from "../ZapCard";
import { type Template } from "@zapier/templates";
import styles from "./TemplateLibraryPage.module.css";

const ZapCardWithRenderedImage = ({
  template,
  imageSizes,
  isLoggedIn,
}: {
  template: Template;
  imageSizes: string;
  isLoggedIn: boolean;
}) => {
  return (
    <ZapCard
      template={template}
      size="responsive"
      isLoggedIn={isLoggedIn}
      hasBookmarking={!!isLoggedIn}
      href={`/templates/details/${template.slug}`}
      renderedImage={
        <CrossDomainImage
          src={
            template.previewImage?.url ??
            "https://images.ctfassets.net/0sppvm4cmdq7/42L9dKclk2wI6gI1Lgas4K/020b75d5c6590d7b4ea21e78a3f6e690/GenericThumbnail.png"
          }
          alt={template.previewImage?.title ?? ""}
          fill
          sizes={imageSizes}
          style={{
            objectFit: "cover",
            objectPosition: "top left",
          }}
        />
      }
    />
  );
};

export const TemplatesGrid = ({
  title,
  templates,
  showcaseTemplate,
  isLoggedIn,
}: {
  title: string;
  templates: Template[];
  showcaseTemplate?: Template;
  isLoggedIn: boolean;
}) => {
  return (
    <div className={styles.templatesContainer}>
      {showcaseTemplate && (
        <div className={styles.showcaseTemplateContainer}>
          <Text type="SectionHeaderMultiline" tag="h2" margin="0 0 12px 0">
            Featured {title.toLowerCase()} template
          </Text>
          <ZapCardWithRenderedImage
            template={showcaseTemplate}
            imageSizes="(max-width: 1024px) 100vw, 50vw"
            isLoggedIn={isLoggedIn}
          />
        </div>
      )}
      {templates.map((template) => (
        <ZapCardWithRenderedImage
          key={template.slug}
          template={template}
          imageSizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
          isLoggedIn={isLoggedIn}
        />
      ))}
    </div>
  );
};
